/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserMessageSeverity = {
    Info: 'Info',
    Warning: 'Warning',
    Error: 'Error'
} as const;
export type UserMessageSeverity = typeof UserMessageSeverity[keyof typeof UserMessageSeverity];


export function instanceOfUserMessageSeverity(value: any): boolean {
    for (const key in UserMessageSeverity) {
        if (Object.prototype.hasOwnProperty.call(UserMessageSeverity, key)) {
            if (UserMessageSeverity[key as keyof typeof UserMessageSeverity] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserMessageSeverityFromJSON(json: any): UserMessageSeverity {
    return UserMessageSeverityFromJSONTyped(json, false);
}

export function UserMessageSeverityFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMessageSeverity {
    return json as UserMessageSeverity;
}

export function UserMessageSeverityToJSON(value?: UserMessageSeverity | null): any {
    return value as any;
}

export function UserMessageSeverityToJSONTyped(value: any, ignoreDiscriminator: boolean): UserMessageSeverity {
    return value as UserMessageSeverity;
}

